module.exports = __webpack_public_path__ + "media/components/app-store/static/ios__qr-download-en-1864c306228ed99badc8046ceb5fbed3.svg";